import React from "react";
import PropTypes from "prop-types";

import { NotificationContainer, typeToColor } from "./style";
import SvgMask from "../SvgMask";

import Info from "~/static/images/icons/info.svg";
import Alert from "~/static/images/icons/alert-triangle.svg";

const typeToIcon = (type) => {
    switch (type) {
        case "alert":
            return Alert;
        // case "ok":
        //     return "check";
        case "error":
            return Alert;
        default:
            return Info;
    }
};

const InlineNotification = (props) => (
    <NotificationContainer {...props}>
        <div className="icon-container">
            <SvgMask
                icon={typeToIcon(props.type)}
                color={typeToColor(props.type)[1000]}
                size={props.big ? 32 : 24}
            />
        </div>
        {props.text}
    </NotificationContainer>
);

InlineNotification.defaultProps = {
    type: "info",
};

InlineNotification.propTypes = {
    type: PropTypes.string,
    stylePropTypes: PropTypes.any,
    text: PropTypes.any,
    big: PropTypes.bool,
};

export default InlineNotification;
